// Import the functions you need from the SDKs you need
import firebase from 'firebase/app'
import 'firebase/firestore'
import "firebase/storage"
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyB4f--5ouWHd8UVA1bwKRhzDzzRxFEUAD8",
  authDomain: "segrate-bb766.firebaseapp.com",
  projectId: "segrate-bb766",
  storageBucket: "segrate-bb766.appspot.com",
  messagingSenderId: "675060085660",
  appId: "1:675060085660:web:cdb4289548065e1cf74e59",
  measurementId: "G-NGXQZBSJDM"
};

// Initialize Firebase
export const db = firebase.initializeApp(firebaseConfig).firestore();